import { render } from "./Atencion_Interconsulta.vue?vue&type=template&id=ee29ce08&scoped=true"
import script from "./Atencion_Interconsulta.vue?vue&type=script&lang=js"
export * from "./Atencion_Interconsulta.vue?vue&type=script&lang=js"

import "@/assets/css/microfono.css?vue&type=style&index=0&id=ee29ce08&scoped=true&lang=css"
import "@/assets/css/listaRegistros.css?vue&type=style&index=1&id=ee29ce08&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee29ce08"]])

export default __exports__